import AddActivityList from "./ManageActivityList";

export default AddActivityList;